import React from 'react';
import numeral from 'numeral';

const Pricebreaks = (props) => {
  const { allowSelect, pricebreaks, selected_pricebreak, onChangePricebreak } =
    props;

  const selected_pricebreak_id = selected_pricebreak
    ? selected_pricebreak.id
    : null;

  if (!pricebreaks || pricebreaks.length < 1) return null;

  return (
    <table className='table table-striped table-pricebreaks'>
      <thead>
        <tr>
          {allowSelect && <th />}
          <th>Qty</th>
          <th>PriceBreak</th>
        </tr>
      </thead>
      <tbody>
        {pricebreaks.map((pricebreak, idx) => {
          const { id, qty, price } = pricebreak;

          return (
            <tr
              key={`pricebreak-${id}-${idx}`}
              className={id === selected_pricebreak_id ? 'selected' : ''}>
              {allowSelect && (
                <td>
                  <input
                    type='radio'
                    key={id}
                    checked={id === selected_pricebreak_id}
                    value={id}
                    name={`pricebreak-${id}-${idx}`}
                    className='pricebreak-radio-btn'
                    onChange={() => onChangePricebreak(idx)} />
                </td>
              )}
              <td>{qty}</td>
              <td>${numeral(price).format('0.0000')}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

Pricebreaks.defaultProps = {
  allowSelect: false, // allow select price break from the list (radios)
};

export default Pricebreaks;
